import { useIsMobile } from 'utils/useIsMobile'
import { HeaderContainer, Th, Title, TxnLabelContainer } from './styles'
import { ActivityHistoryFilter } from './ActivityHistoryFilter'

interface Props {
  filters: Record<string, boolean>
  handleFilterClick: (filterName: string) => void
  filterItems: string[]
  disabledFilter?: boolean
}

export const Header = ({ filters, handleFilterClick, filterItems, disabledFilter }: Props) => {
  const isMobile = useIsMobile()

  return (
    <>
      <Title
        variant="label1"
        fontWeight="semiBold"
        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative' }}
      >
        Activity History
        <ActivityHistoryFilter
          filters={filters}
          onChange={handleFilterClick}
          items={filterItems}
          disabledFilter={disabledFilter}
        />
      </Title>
      {isMobile ? (
        <HeaderContainer>
          <Th variant="description" fontWeight="semiBold" style={{ flexBasis: '45%' }}>
            Date
          </Th>
          <Th variant="description" fontWeight="semiBold" style={{ flexBasis: '45%' }}>
            Activity
          </Th>
          <Th variant="description" fontWeight="semiBold" style={{ flexBasis: '10%' }}>
            <span></span>
          </Th>
        </HeaderContainer>
      ) : (
        <HeaderContainer style={{ position: 'relative' }}>
          <Th variant="description" fontWeight="semiBold">
            Date
          </Th>
          <Th variant="description" fontWeight="semiBold">
            Activity
          </Th>
          <Th variant="description" fontWeight="semiBold" style={{ flexBasis: 600 }}>
            Details
          </Th>
          <TxnLabelContainer>
            <Th variant="description" fontWeight="semiBold">
              Txn
            </Th>
          </TxnLabelContainer>
        </HeaderContainer>
      )}
    </>
  )
}
